var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.274a.75.75 0 0 1-.648.743l-.102.007H6.066l4.763 4.743a.75.75 0 0 1-.974 1.136l-.084-.073-6.05-6.024a.758.758 0 0 1-.22-.503l-.001-.029v-.029a.76.76 0 0 1 .003-.044l-.003.073a.754.754 0 0 1 .148-.446l.006-.01a.757.757 0 0 1 .066-.074l6.05-6.026a.75.75 0 0 1 1.132.98l-.073.083-4.761 4.743H19.25a.75.75 0 0 1 .75.75Z"
  })));
};
export default SvgArrowLeft;